<script context="module">
    let dropTarget;
</script>

<script>
    import {slide} from 'svelte/transition';
    import {createEventDispatcher} from 'svelte';
    import ListItemNameControl from '../RoleSequenceList/ListItemNameControl.svelte';
    import ContextMenu from '../../Menu/ContextMenu.svelte';
    import {ACTIVITY_ROLE_API} from '../../../apiUrls.js';
    import {post} from '../../../utils.js';
    import {selectable} from './actions/selectable.js';
    import {
        setSelectedRole, clearSelectedListItems, isCopy,
        selectedListItems, saveToLocalStorage
    } from './utils.js';
    import {
        roles,
        activityVersion,
        isActivityVersionHeaderSelected,
    } from '../workspacesStore.js';

    export let role = {};
    export let editable = false;

    const dispatch = createEventDispatcher();

    let showMenu = false;
    let menuPosition = null;
    let activeMenu = null;
    let menuContext = null;
    let currentAction = '';
    let showContent = true;

    async function updateRoleMoved(payload) {
        const url = `${ACTIVITY_ROLE_API}paste/`;

        const resp = await post(url, payload);

        if (resp.ok) {
            selectedListItems.set([]);
        }
    }

    async function onDroppedIntoRole(event) {
        if (editable && event.detail.droppedData) {
            isCopy.set(false);
            if (event.detail.droppedData.hasOwnProperty('worksequences')) {
                const payload = {
                    selected: [event.detail.droppedData.id],
                    target: {
                        role_id: dropTarget.id,
                        is_after: event.detail.isAfter
                    },
                    is_copy: $isCopy,
                    activity_version_id: $activityVersion.id
                };

                await updateRoleMoved(payload);
            } else if (event.detail.droppedData.hasOwnProperty('element_instances')) {

            }
        }
    }

    function onRoleMenuClick(event) {
        dispatch('showMenu', {
            event,
            entityType: 'role',
            entity: role
        });
    }


    async function updateRoleName(role) {
        const url = `${ACTIVITY_ROLE_API}${role.id}/update_name/`;

        await post(url, {name: role.name});
    }

    function toggleCollapsible() {
        showContent = !showContent;
    }


    function handleSelection(event) {
        if (event.detail.event.button === 0) {
            const updated = clearSelectedListItems($roles);
            roles.set(setSelectedRole(updated, role.id));
            selectedListItems.set([role]);
            saveToLocalStorage('selectedListItems', JSON.stringify($selectedListItems));
            isActivityVersionHeaderSelected.set(false);
        }

    }
</script>

<style>
    .fas {
        cursor: pointer;
    }

    .toggle-expand {
        margin-right: 10px;
    }

    .fas:hover {
        color: #ffd691;
    }

    .panel {
        flex: 1;
        height: 100%;
    }

    .menu-toggle {
        width: 20px;
        text-align: center;
        color: #dddddd;
        cursor: pointer;
    }

    .title {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .body {
        height: calc(100% - 34px);
    }

    header {
        background-color: #6c757d;
        padding: 5px 0 5px 10px;
        color: white;
        display: flex;
        height: 34px;
    }

    .header-container {
        position: sticky;
        top: 0;
    }

    header.selected {
        background-color: #fab636;
    }

    .cut {
        opacity: 0.5;
        border: 1px dashed #454545;
    }

    :global(.drag-over) {
        border: 1px solid #fab636;
    }

    .shadow {
        opacity: 0.3;
    }
</style>


<div
    class:copied={role.copied}
    class:cut={role.cut}
    class="panel role wrapper"
    class:draggable={editable}
    class:shadow={role.shadow}
    data-id="{role.id}"
    data-type="role"
    id="{`role${role.id}`}"
>
    <div class="header-container">
        <header
            use:selectable={{item:role}}
            on:mouseDown|preventDefault|stopPropagation={handleSelection}
            class:selected={role.selected}
            class="drag-handler selectable"
            class:droppable={editable}
            on:contextmenu|preventDefault|stopPropagation={onRoleMenuClick}
        >
            <span>
                <i
                    on:click={toggleCollapsible}
                    class:fa5-plus={!showContent}
                    class:fa5-minus={showContent}
                    class="fas toggle-expand"
                    aria-hidden="true"/>
            </span>
            <span title={role.name} class="title">
                <ListItemNameControl
                    {editable}
                    row={role}
                    col="name"
                    save={updateRoleName}/>
            </span>
            <slot name="headerExtra">

            </slot>
            <div
                class="menu-toggle"
                class:editable
                on:mousedown={event => event.stopPropagation()}
                on:click|stopPropagation|preventDefault={onRoleMenuClick}
            ><i class="fas fa-ellipsis-v"></i></div>
        </header>
        <slot name="subHeader"/>    
    </div>

    {#if showContent}

        <div
            class="body ignore"
            transition:slide|local="{{duration: 300 }}">
            <slot/>
        </div>
    {/if}
</div>

{#if showMenu}
    <ContextMenu
        bind:showMenu={showMenu}
        {currentAction}
        items={activeMenu}
        position={menuPosition}
    />
{/if}
